export function openDocumentGallery(documents, shipmentLabel = "Shipment Documents") {
  if (!documents.length) return;

  const previewWindow = window.open("", "_blank");
  if (!previewWindow) return;

  const safe = (value) => String(value || "").replace(/[&<>'"]/g, (char) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;",
  }[char]));
  const items = documents.filter((doc) => doc.document_url).map((doc, index) => ({
    name: doc.document_name || doc.document_title || `Document ${index + 1}`,
    url: doc.document_url,
  }));

  const buttons = items.map((item, index) => `
    <button class="doc-button ${index === 0 ? "active" : ""}" data-index="${index}">
      ${safe(item.name)}
    </button>`).join("");
  const urls = JSON.stringify(items.map((item) => item.url));

  previewWindow.document.write(`<!doctype html><html><head><title>${safe(shipmentLabel)}</title>
    <style>
      *{box-sizing:border-box}body{margin:0;font-family:Arial,sans-serif;background:#f3f4f6;color:#173f68}
      header{background:#fff;padding:24px 32px;border-bottom:1px solid #dbe3ec;position:sticky;top:0;z-index:2}
      h1{margin:0 0 16px;font-size:24px}.documents{display:flex;gap:8px;flex-wrap:wrap}
      .doc-button{border:0;border-radius:6px;padding:10px 14px;background:#e8edf3;color:#23476b;cursor:pointer;font-weight:600}
      .doc-button.active{background:#145486;color:#fff}.viewer{padding:24px 32px;height:calc(100vh - 150px)}
      iframe{width:100%;height:100%;border:1px solid #d1d9e2;border-radius:8px;background:#fff}
      .empty{padding:32px;background:#fff;border-radius:8px;color:#555}
    </style></head><body><header><h1>${safe(shipmentLabel)}</h1>
      <div class="documents">${buttons}</div></header><main class="viewer">
      ${items.length ? `<iframe id="preview" src="${safe(items[0].url)}" title="Document preview"></iframe>` : `<div class="empty">No previewable documents available.</div>`}
    </main><script>
      const urls = ${urls};
      document.querySelectorAll('.doc-button').forEach((button) => button.addEventListener('click', () => {
        document.querySelectorAll('.doc-button').forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        document.getElementById('preview').src = urls[button.dataset.index];
      }));
    </script></body></html>`);
  previewWindow.document.close();
}
